import Box from '@mui/material/Box';
import classNames from 'classnames';
import React, { memo } from 'react';
import { useLocation } from 'react-router';

import ToggleMapButtonMobile from '../../components/BasicUI/Button/ToogleMapButtonMobile';
import ModalInMobile from '../../components/Modal/ModalInMobile/ModalInMobile';
import MapSlot from '../../components/SearchMap/MapSlot';
import { MAP_CHANNELS } from '../../components/SearchMap/mapChannels';
import useScreenSize from '../../util/hooks/useScreenSize';
import { MODAL_BREAKPOINT } from '../../util/mobile/mobile';
import MainPanel from './MainPanel';
import {
  SEARCH_PAGE_MAP_PANEL,
  SEARCH_PAGE_MAP_PANEL_STORYBLOK,
  SEARCH_PAGE_MODAL_CONTAINER,
  SEARCH_PAGE_MODAL_STORYBLOK_CONTAINER,
  SearchPageContentGlobalStyles,
} from './searchPageContentStyles';

const SearchPageContentComponent = ({
  amountListings = 100,
  bounds,
  isSearchMapOpenOnMobile = false,
  listings,
  onActivateListing,
  onListIconClick,
  onManageDisableScrolling,
  onMapIconClick,
  onMapMoveEnd,
  origin = null,
  pagination = null,
  paginationPageName = 'SearchPage',
  paginationPathParams = {},
  searchParamsForPagination,
  searchInProgress = false,
  searchListingsError = null,
  searchParamsAreInSync,
  urlCategory,
  isStoryblok = false,
  validQueryParams,
  setIsSearchMapOpenOnMobile = false,
  shouldShowSearchMap = false,
  isLandingPage = false,
  disableHoverOnListings = false,
}) => {
  const location = useLocation();
  const { isMobile } = useScreenSize();

  const searchParams = new URLSearchParams(location.search);
  const hasMobileSearch = searchParams.get('mobileSearch') === 'open';

  return (
    <Box
      sx={{
        width: '100%',
        ...(isStoryblok ? { display: 'flex' } : {}),
      }}
    >
      <SearchPageContentGlobalStyles />
      {isMobile && !isLandingPage ? (
        <ToggleMapButtonMobile
          onListIconClick={onListIconClick}
          onMapIconClick={onMapIconClick}
          shouldShowSearchMap={shouldShowSearchMap}
        />
      ) : null}

      <MainPanel
        amountListings={amountListings}
        disableHoverOnListings={disableHoverOnListings}
        inSearchPage={!isStoryblok}
        isLandingPage={isLandingPage}
        isStoryblok={isStoryblok}
        listings={listings}
        onActivateListing={onActivateListing}
        onListIconClick={onListIconClick}
        onManageDisableScrolling={onManageDisableScrolling}
        onMapIconClick={onMapIconClick}
        pagination={pagination}
        paginationPageName={paginationPageName}
        paginationPathParams={paginationPathParams}
        searchInProgress={searchInProgress}
        searchListingsError={searchListingsError}
        searchParamsAreInSync={searchParamsAreInSync}
        searchParamsForPagination={searchParamsForPagination}
        shouldShowSearchMap={shouldShowSearchMap}
        showAsModalMaxWidth={MODAL_BREAKPOINT}
        urlCategory={urlCategory}
        urlQueryParams={validQueryParams}
      />

      <ModalInMobile
        className={classNames(SEARCH_PAGE_MAP_PANEL, {
          [SEARCH_PAGE_MAP_PANEL_STORYBLOK]: isStoryblok,
        })}
        containerClassName={
          isStoryblok ? SEARCH_PAGE_MODAL_STORYBLOK_CONTAINER : SEARCH_PAGE_MODAL_CONTAINER
        }
        id="SearchPage.map"
        isModalOpenOnMobile={isSearchMapOpenOnMobile}
        onClose={() => setIsSearchMapOpenOnMobile(false)}
        onManageDisableScrolling={onManageDisableScrolling}
        showAsModalMaxWidth={MODAL_BREAKPOINT}
        showCloseButton={hasMobileSearch}
      >
        {shouldShowSearchMap ? (
          <MapSlot
            bounds={bounds}
            center={origin}
            channel={MAP_CHANNELS.SEARCH}
            layout={isStoryblok ? 'storyblok' : 'searchColumn'}
            listings={listings}
            onCloseAsModal={() => onManageDisableScrolling('SearchPage.map', false)}
            onMapMoveEnd={onMapMoveEnd}
            urlCategory={urlCategory}
          />
        ) : null}
      </ModalInMobile>
    </Box>
  );
};

SearchPageContentComponent.displayName = 'SearchPageContent';

const SearchPageContent = memo(SearchPageContentComponent);

export default SearchPageContent;
